import { Component, Input, OnInit } from '@angular/core';
import { FraudTaskStatusEnum } from '../../../models/fraud-monitoring-tasks/enums/FraudTaskStatusEnum';
import { Status } from '../../../models/fraud-monitoring-tasks/TaskDetails';

@Component({
  selector: 'app-fraud-monitoring-tasks-status',
  standalone: false,
  templateUrl: './fraud-monitoring-tasks-status.component.html'
})
export class FraudMonitoringTasksStatusComponent implements OnInit {

  @Input({ required: true }) status: Status;
  taskStatusEnum = FraudTaskStatusEnum;

  constructor() { }

  ngOnInit() {
  }
}
